import {Loader} from "@googlemaps/js-api-loader"
import Slider from "@/components/Slider";
import marker from '../../assets/svg/marker.svg'

import './style.css'


export default class PropertyPage {
    static selector = '.property'

    constructor(block) {
        this.block = block;
        this.mapGetDirections = this.block.querySelector('.property__get-dir');
        this.mobileTopper = this.block.querySelector('.property__fixed-top');
        this.requestInfoBtn = this.block.querySelector('#request-info');
        this.requestInfoBtnTop = this.block.querySelector('#request-info-top');
        this.requestInfoBtnMobile = this.block.querySelector('#request-info-mobile');

        this.sliderItems = this.block.querySelectorAll(".property__slider-item");

        this.dotsContainer = this.block.querySelector(".carousel-dots");

        this.backBtns = this.block.querySelectorAll('.property__back');

        Array
            .from(this.backBtns)
            .forEach(back => {
                back.addEventListener('click', this.goBack);
            });
    }

    initMap() {
        const {lat, lng} = this.block.dataset;

        if (!lat || !lng) {
            return;
        }

        const mapLoader = new Loader({
            apiKey: process.env.GOOGLE_MAPS_API_KEY,
            version: "weekly",
        });

        mapLoader.load().then(() => {
            const position = new google.maps.LatLng(lat, lng);
            const map = new google.maps.Map(
                this.block.querySelector("#map"
                ), {
                    center: position,
                    zoom: 16,
                });

            new google.maps.Marker({
                position: position,
                icon: marker,
                map: map,
            });
        })
    }

    openRequestModal() {
        const propertyInput = window.App.modals.requestInfoModal.block.querySelector('#property');
        propertyInput.value = this.block.dataset.subtitleForModal;
        
        const propertyIdInput = window.App.modals.requestInfoModal.block.querySelector('#property-id');
        propertyIdInput.value = this.block.dataset.id;

        const requestTargetEmailInput = window.App.modals.requestInfoModal.block.querySelector('#targetEmail');
        requestTargetEmailInput.value = this.block.dataset.requestEmail;

        window.App.modals.requestInfoModal.subtitle.innerText = this.block.dataset.subtitleForModal;
        window.App.modals.requestInfoModal.open();
    }

    onComplete() {
        const {lat, lng} = this.block.dataset;
        if (this.requestInfoBtnTop) {
            this.requestInfoBtnTop.addEventListener('click', this.openRequestModal.bind(this));
        }

        if (this.requestInfoBtnMobile) {
            this.requestInfoBtnMobile.addEventListener('click', this.openRequestModal.bind(this));
        }

        this.initMap();
        this.requestInfoBtn.addEventListener('click', this.openRequestModal.bind(this));

        if (this.mapGetDirections && lat && lng) {
            this.mapGetDirections.href = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;
        }

        this.sliderItems.forEach(() => {
            var node = document.createElement("button");
            node.classList.add("carousel-dots__dot");
            this.dotsContainer.appendChild(node);
        });
      
        this.dots = this.block.querySelectorAll(".carousel-dots__dot");
        if (this.dots.length > 0) {
            this.dots[0].classList.add("active");
            
            this.propertySlider = new Slider({
            container: this.block.querySelector("#property-slider"),
            controlsContainer: this.block.querySelector(".property__slider-nav"),
            navContainer: this.dotsContainer,
            items: 1,
            gutter: 20,
            autoplayButton: false,
            responsive: {
                1025: {
                autoplay: true,
                },
            },
            });
            this.handleListeners();
        }
    }

    handleListeners = () => {
        this.propertySlider.slider.events.on("indexChanged", this.handleControls);
    };
    
    handleControls = (e) => {
        this.dots.forEach((dot, i) => {
          if (i === e.index) {
            dot.classList.add("active");
          } else {
            dot.classList.remove("active");
          }
        });
    };

    onScroll() {
        if (window.scrollY > 175) {
            this.mobileTopper.classList.add('show-first');
        } else {
            this.mobileTopper.classList.remove('show-first');
        }

        if (window.scrollY > 860) {
            this.mobileTopper.classList.add('show-second');
        } else {
            this.mobileTopper.classList.remove('show-second');
        }
    }

    goBack(e) {
        e.preventDefault();
        window.App.navigateTo(window.App.previousUrl ? window.App.previousUrl : '/our-properties/');
    }
}
